import React from 'react';
export default function HowItWorks() {
  return (
    <>
      <h2>Premium</h2>
      Thank you for your interest in supporting Ban Appeals! Premium is not currently available. 
      If you would like to make a donation to support our development, please contact us via our support server: <a href="/support" target="_blank" rel="noopener noreferrer">here</a>
    </>
  );
}